import { render, staticRenderFns } from "./tvView.vue?vue&type=template&id=562813f0&scoped=true"
import script from "./tvView.vue?vue&type=script&lang=js"
export * from "./tvView.vue?vue&type=script&lang=js"
import style0 from "./tvView.vue?vue&type=style&index=0&id=562813f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562813f0",
  null
  
)

export default component.exports